import { ConfirmDialog } from "./ConfirmDialog";

type Props = {
  isOpen: boolean;
  onDiscard: () => void;
  onContinue: () => void;
  title: string;
  body: string;
  discardLabel: string;
  continueLabel: string;
  /** Raise above another open modal when nested inside one (see ModalSheet.elevated). */
  elevated?: boolean;
};

/**
 * "Unsaved changes" dialog. Thin wrapper over ConfirmDialog so it inherits the
 * exact confirm-modal experience (centered scale-in, danger icon tile, right-
 * aligned actions). Discard is the destructive (red) action; Continue editing
 * is the safe default (outline) and is what Escape/backdrop resolve to.
 */
export function DiscardChangesDialog({
  isOpen,
  onDiscard,
  onContinue,
  title,
  body,
  discardLabel,
  continueLabel,
  elevated = false,
}: Props) {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={title}
      body={body}
      intent="danger"
      elevated={elevated}
      confirmLabel={discardLabel}
      cancelLabel={continueLabel}
      onConfirm={onDiscard}
      onCancel={onContinue}
    />
  );
}
